
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import './layout-grid'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "gridlayout"
    }}>{`GridLayout`}</h1>
    <h2 {...{
      "id": "grid-layout"
    }}>{`Grid layout`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;